import $ from 'jquery';
import { Component } from '../core/component';

export class ContactForm extends Component {
    constructor() {
        super();
        this.selector = '.js-contact-form';
    }

    init() {
        /* eslint-disable no-unused-vars */
        this.$elements.each((index, element) => {
            $('.js-contact-form').on('submit', function (e) {
                if ($('input#newsletter-signup').is(':checked')) {
                    e.preventDefault();
                    $.post(
                        '/actions/mailchimp-subscribe/list/subscribe',
                        $.param({
                            email: $('input[name$="fromEmail"]').val(),
                            CRAFT_CSRF_TOKEN: $('input[name$="CRAFT_CSRF_TOKEN"]').val(),
                        }),
                    );
                }
            });
        });
    }
}



// WEBPACK FOOTER //
// ./assets/js/components/contact-form.js